
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CreateOrUpdateShortlistRequest,
  ShortlistResponse,
} from '../models';
import {
    CreateOrUpdateShortlistRequestFromJSON,
    CreateOrUpdateShortlistRequestToJSON,
    ShortlistResponseFromJSON,
    ShortlistResponseToJSON,
} from '../models';

export interface CreateOrUpdateShortlistOperationRequest {
    createOrUpdateShortlistRequest: CreateOrUpdateShortlistRequest;
}

export interface RemoveProfileFromShortlistRequest {
    profileId: string;
}

/**
 * 
 */
export class ShortlistApi extends runtime.BaseAPI {

    /**
     * Create or update shortlist
          */
    async createOrUpdateShortlistRaw(requestParameters: CreateOrUpdateShortlistOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['createOrUpdateShortlistRequest'] == null) {
            throw new runtime.RequiredError(
                'createOrUpdateShortlistRequest',
                'Required parameter "createOrUpdateShortlistRequest" was null or undefined when calling createOrUpdateShortlist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/public-api/shortlist`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateShortlistRequestToJSON(requestParameters['createOrUpdateShortlistRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Create or update shortlist
          */
    async createOrUpdateShortlist(requestParameters: CreateOrUpdateShortlistOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.createOrUpdateShortlistRaw(requestParameters, initOverrides);
    }

    /**
     * Find shortlist for current session
          */
    async findCurrentShortlistRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ShortlistResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ShortlistResponse>({
            path: `/profile/public-api/shortlist`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ShortlistResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Find shortlist for current session
          */
    async findCurrentShortlist(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ShortlistResponse> {
        const response = await this.findCurrentShortlistRaw(initOverrides);
        return response._data;
    }

    /**
     * Remove profile from current shortlist
          */
    async removeProfileFromShortlistRaw(requestParameters: RemoveProfileFromShortlistRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling removeProfileFromShortlist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/public-api/shortlist/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Remove profile from current shortlist
          */
    async removeProfileFromShortlist(requestParameters: RemoveProfileFromShortlistRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.removeProfileFromShortlistRaw(requestParameters, initOverrides);
    }

}
